module.exports = __webpack_public_path__ + "static/media/guide-line-11.78335a49.svg";